import Rosary from "./16_l.webp";
import Crucifixion from "./381_l.webp";
import PadrePio from "./662_l.webp";
import Emmaus from "./741_l.webp";
import MonicaAugustine from "./1197_l.webp";
import MaximilianKolbe from "./1744_l.webp";

export {
  Crucifixion,
  Rosary,
  PadrePio,
  Emmaus,
  MonicaAugustine,
  MaximilianKolbe,
};
